import Vue from "vue";
import Router from "vue-router";
import login from "@/components/login";
import index from "@/components/index";

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/login",
            name: "login",
            component: login
        },
        {
            path: "/",
            name: "index",
            component: index
        },
        {
            path: "/study/qst_item_real",
            name: "qst_item_real",
            component: ()=>import('@/components/study/qst_item_real')
        },
        {
            path: "/study/paper_record",
            name: "paper_record",
            component: ()=>import('@/components/study/paper_record')
        },
        {
            path: "/study/practice_chapter",
            name: "practice_chapter",
            component: ()=>import('@/components/study/practice_chapter')
        },
        {
            path: "/study/qst_item_chapter",
            name: "qst_item_chapter",
            component: ()=>import('@/components/study/qst_item_chapter')
        },
        {
            path: "/study/fav_portal",
            name: "fav_portal",
            component: ()=>import('@/components/study/fav_portal')
        },
        {
            path: "/study/qst_item_fav",
            name: "qst_item_fav",
            component: ()=>import('@/components/study/qst_item_fav')
        },
        {
            path: "/live/live_show",
            name: "live_show",
            component: ()=>import('@/components/live/live_show')
        },

        // { path: '/activiti/process', component: _import('@/components/activiti/process'), name: 'activiti-process', meta: { title: '流程', isTab: true } },
        // { path: '/activiti/detail/:id', component: _import('@/components/activiti/detail'), name: 'activiti-detail', meta: { title: 'detail' } },
        // { path: '/activiti/task', component: _import('@/components/activiti/task'), name: 'activiti-task', meta: { title: '任务', isTab: true } }
    ]
});

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

const whiteList = {
    "/live/live_show": true
};

router.beforeEach((to, from, next) => {
    // console.log(to.path);
    // console.log(to);
    // console.log(from);
    // console.log(next);

    // 回话管理模式待定，优先使用session，其次考虑拦截器自己实现，不考虑shiro
    const token = sessionStorage.getItem("hwt-token");
    if (to.path === "/login") {
        if (token !== "null" && token !== null) {
            next("/");
        }
        next();
    } else if (whiteList[to.path]) {
        next();
    } else {
        if (token !== "null" && token !== null) {
            // 待验证作用
            next();
        } else {
            next("/login");
        }
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js